module.exports = __webpack_public_path__ + "static/media/ci.26a62321.svg";